module.exports = __webpack_public_path__ + "static/media/Mulish-Bold.91636bbb.woff";